import type { GlossaryKey } from 'naban/glossary/types';
import { create } from 'zustand';

import type { AuthenticationMethod, OverviewTabOption } from './types';

interface NabanStore {
  selectedAuthenticationMethod?: AuthenticationMethod | null;
  selectedGlossaryModalKey: GlossaryKey | null;
  selectedOverviewTabOption: OverviewTabOption;
  setAuthenticationMethod: (
    nextAuthenticationMethod: AuthenticationMethod | null | undefined,
  ) => void;
  setGlossaryModalKey: (glossaryKey: GlossaryKey | null) => void;
  setSelectedOverviewTabOption: (overviewTabOption: OverviewTabOption) => void;
}

export const useNabanStore = create<NabanStore>()((set) => ({
  selectedGlossaryModalKey: null,
  selectedOverviewTabOption: 'deeds',
  setAuthenticationMethod: (authenticationMethod) =>
    set({ selectedAuthenticationMethod: authenticationMethod }),
  setGlossaryModalKey: (selectedGlossaryModalKey) => set({ selectedGlossaryModalKey }),
  setSelectedOverviewTabOption: (selectedOverviewTabOption) => set({ selectedOverviewTabOption }),
}));

export const useNabanStoreSelectedAuthenticationMethod = () =>
  useNabanStore((store) => store.selectedAuthenticationMethod);
export const useNabanStoreSetAuthenticationMethod = () =>
  useNabanStore((store) => store.setAuthenticationMethod);
export const useNabanStoreSelectedGlossaryModalKey = () =>
  useNabanStore((store) => store.selectedGlossaryModalKey);
export const useNabanStoreSetGlossaryModalKey = () =>
  useNabanStore((store) => store.setGlossaryModalKey);
export const useNabanStoreSelectedOverviewTabOption = () =>
  useNabanStore((store) => store.selectedOverviewTabOption);
export const useNabanStoreSetOverviewTabOption = () =>
  useNabanStore((store) => store.setSelectedOverviewTabOption);
